import {filter, map} from 'rxjs/operators';
import {contractBiz$, PayLoad} from '@/contract-biz/contract-biz';

export const updateAirdropPosition$ = contractBiz$.pipe(
  map((o: PayLoad[]) => !!o.find((item) => item.eventType === 'airdropPosition')),
  filter(Boolean)
);
